import { PortfolioProjectCardAttachment } from '../../components';

export const getAttachmentType = (attachments?: PortfolioProjectCardAttachment[]) => attachments?.[0]?.type;
